import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter025() {
  return <KbChapterPage slug="chapter-025" />;
}

(Chapter025 as unknown as { path: string }).path = "/theory-album/025";
